// extracted by mini-css-extract-plugin
export default {"tabs":"kJvOmVL","tablist":"eA3IfaK","s200":"HzJW9wt","button":"K5FO964","s300":"A2mVi7v","stretch":"CSXIMAe","active":"iGDosr2","panel":"XiFk4HB"};